import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { BANK_CARDS_ENDPOINTS } from 'src/app/core/api/endpoints/bank-cards.endpoints';

@Injectable({
  providedIn: 'root'
})
export class BankCardsService {
  private api = inject(ApiService);

  getBanks(): Observable<any> {
    return this.api.get(BANK_CARDS_ENDPOINTS.V1.BANKS);
  }

  getAllBanks(): Observable<any> {
    return this.api.get(BANK_CARDS_ENDPOINTS.V1.ALL_BANKS);
  }

  getBankByID(id): Observable<any> {
    return this.api.get(BANK_CARDS_ENDPOINTS.V1.BANK_DETAIL(id));
  }

  putBankByID(id, bankData): Observable<any> {
    return this.api.put(BANK_CARDS_ENDPOINTS.V1.BANK_DETAIL(id), bankData);
  }

  deletBank(id) {
    return this.api.delete(BANK_CARDS_ENDPOINTS.V1.BANKS, { body: id });
  }

  addBankCard(data): Observable<any> {
    return this.api.post(BANK_CARDS_ENDPOINTS.V1.BANKS, data);
  }

  getBanksByPage(params): Observable<any> {
    return this.api.get(BANK_CARDS_ENDPOINTS.V1.BANKS, {
      params: params,
    });
  }
}
